import { env, type AppRegion } from './env';

const productionStaticOriginByRegion: Record<AppRegion, string> = {
  development: 'https://play.creaticode.com',
  us: 'https://play.creaticode.com',
  cn: 'https://play.creaticode.cn',
};

function trimLeadingSlash(filePath: string) {
  return filePath.replace(/^\/+/, '');
}

function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function isLocalHost(url: string) {
  const { hostname } = new URL(url);

  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
}

export function resolveStaticAssetOrigin(playgroundUrl: string, region: AppRegion) {
  const normalizedPlaygroundUrl = trimTrailingSlash(playgroundUrl);

  if (!isLocalHost(normalizedPlaygroundUrl)) {
    return normalizedPlaygroundUrl;
  }

  return productionStaticOriginByRegion[region];
}

const staticBase = `${resolveStaticAssetOrigin(env.playgroundUrl, env.VITE_REGION)}/tcode-static-files`;

export const assetBasePaths = {
  images: `${staticBase}/images`,
  fonts: `${staticBase}/fonts`,
  css: `${staticBase}/css`,
  js: `${staticBase}/js`,
  other: `${staticBase}/other`,
} as const;

export type AssetKind = keyof typeof assetBasePaths;

export function buildStaticAssetUrl(kind: AssetKind, filePath: string) {
  return `${assetBasePaths[kind]}/${trimLeadingSlash(filePath)}`;
}

export const assets = {
  staticBase,
  ...assetBasePaths,
  cdn: env.cdnUrl,
} as const;
